export const CreatePasswordTestIDs = {
  termsAndConditionsCheckbox: "create-password-terms-and-conditions-checkbox",
  privacyPolicyCheckbox: "create-password-privacy-policy-checkbox",
  passwordInput: "create-password-input",
  passwordConfirmInput: "create-password-confirm-input",
  submitButton: "create-password-submit-button",
};
